


































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
// Components
import ElementResultsTooltip from '@/components/elements/ElementResultsTooltip.vue';

@Component({
  components: {
    ElementResultsTooltip,
  },
})
export default class ChartRawGaugeSlider extends Vue {
  @Prop({ required: true }) data!: any;
  @Prop({ default: false }) simple!: boolean;

  colors: any = {
    neutral: '#e6e8ed',
    goodRange: '#25c090',
    warningRange: '#ffbe13',
    badRange: '#ff5e13',
  };

  // SYMMETRY CHART
  radius: number = 35;
  get strokeWidth() {
    return this.radius * 0.11;
  }
  get innerRadius() {
    return this.radius - this.strokeWidth;
  }
  get circumference() {
    return this.innerRadius * 2 * Math.PI;
  }
  get arc() {
    return this.circumference * (270 / 360);
  }
  get dashArray() {
    return `${this.arc} ${this.circumference}`;
  }
  get offset() {
    return this.arc - (this.data.value / 100) * this.arc;
  }
  get transform() {
    return `rotate(135, ${this.radius}, ${this.radius})`;
  }

  get symmetryColor() {
    switch (true) {
      case this.data.value >= 80:
        return this.colors.goodRange;
      case this.data.value < 80 && this.data.value >= 70:
        return this.colors.warningRange;
      case this.data.value < 70:
        return this.colors.badRange;
      default:
        return this.colors.neutral;
    }
  }
}
